import i18n from "i18next";
import { useTranslation, initReactI18next } from "react-i18next";
import Backend from "i18next-xhr-backend";

i18n
  .use(initReactI18next)
  .use(Backend)
  .init({
    lng: "he",
    fallbackLng: "en",

    interpolation: {
      escapeValue: false,
    },
  });
